module.exports = __webpack_public_path__ + "static/img/invest-consume15.d1c194f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume15.jpg
// module id = X3b6
// module chunks = 0